@if (wizardState && !isOnProfilePage) {
<div class="wizard-banner">
  <div class="banner-inner">

    <span class="banner-section-label">Profile:</span>

    <div class="banner-steps">
      @for (step of steps; track step; let i = $index) {
      <button [class]="'step-pill state-' + getStepState(i)"
        (click)="goToStep(i)" [attr.aria-label]="step.displayName">
        <span class="pill-num">{{ i + 1 }}</span>
      </button>

      @if (i < steps.length - 1) {
      <div class="step-connector" [class.filled]="steps[i].isComplete"></div>
      }
      }
    </div>

  </div>

  <button mat-icon-button class="dismiss-btn" (click)="dismiss()" aria-label="Exit guided setup"
    data-testid="exit-guided-setup">
    <mat-icon>close</mat-icon>
  </button>
</div>
}
